import React, { useEffect, useState } from "react";
import Header from "../../../component/organisms/header";
import MainLayout from "../../../component/atoms/layout/mainLayout";
import Sidebar from "../../../component/organisms/sidebar";
import DetailPageLayout from "../../../component/atoms/layout/detail/detailPageLayout";
import { useLocation, useNavigate } from "react-router-dom";
import TableTitle from "./../../../component/atoms/text/table/tableTitle";
import styled from "styled-components";
import PretendardText from "../../../component/atoms/text/pretendardText";
import { route } from "../../../router/route";
import SelectBox from "../../../component/organisms/selectBox";
import EventBtn from "./../../../component/atoms/button/eventBtn";
import Table from "./../../../component/atoms/layout/table/table";
import Tr from "./../../../component/atoms/layout/table/tr";
import Th from "./../../../component/atoms/layout/table/th";
import Td from "./../../../component/atoms/layout/table/td";
import TableText from "./../../../component/atoms/text/table/tableText";
import Checkbox from "../../../component/atoms/input/checkbox";
import SelectGroupBox from "./_components/selectGroupBox";
import MainInput from "./../../../component/atoms/input/mainInput";
import GrayBtn from "./../../../component/atoms/button/grayBtn";
import SelectBoxValue from "../../../component/organisms/selectBoxValue";

const OperationMessageEmail = () => {
  const location = useLocation();

  const navigate = useNavigate();

  // ---------- 서비스 제공업체 관련 ---------- //
  const companyList = [
    {
      title: "Gmail",
      value: "Gmail",
    },
    {
      title: "네이버",
      value: "네이버",
    },
    {
      title: "다음",
      value: "다음",
    },
    {
      title: "네이트",
      value: "네이트",
    },
    {
      title: "사용자 지정 SMTP 서버",
      value: "사용자 지정 SMTP 서버",
    },
  ];

  const [selectedCompany, setSelectedCompany] = useState("Gmail");

  const [companyListBoxOpen, setCompanyListBoxOpen] = useState(false);

  // ---------- 계정 연결 관련 ---------- //
  const [showGoogleAccountSetting, setShowGoogleAccountSetting] =
    useState(false);

  const [isAccountConnected, setIsAccountConnected] = useState({
    google: true,
    naver: false,
    daum: false,
    nate: false,
    smtp: false,
  });

  // useEffect(() => {
  //   setIsAccountConnected({
  //     google: false,
  //     naver: false,
  //     daum: false,
  //     nate: false,
  //     smtp: false,
  //   });
  // }, [selectedCompany]);

  // ---------- 자동 메일 설정 관련 ---------- //
  const autoSendGroupList = [
    { title: "운영 - 그룹1", value: "운영 - 그룹1" },
    { title: "운영 - 그룹2", value: "운영 - 그룹2" },
    { title: "운영 - 그룹3", value: "운영 - 그룹3" },
    { title: "운영 - 그룹4", value: "운영 - 그룹4" },
  ];

  const [autoSendSettingList, setAutoSendSettingList] = useState([
    {
      title: "가입완료",
      member: true,
      owner: true,
      group: "",
      groupListBoxOpen: false,
    },
    {
      title: "결제 완료 안내",
      member: true,
      owner: true,
      group: "",
      groupListBoxOpen: false,
    },
    {
      title: "취소 요청 접수",
      member: true,
      owner: true,
      group: "",
      groupListBoxOpen: false,
    },
    {
      title: "취소 완료",
      member: true,
      owner: true,
      group: "",
      groupListBoxOpen: false,
    },
    {
      title: "1:1 문의 등록",
      member: true,
      owner: true,
      group: "",
      groupListBoxOpen: false,
    },
    {
      title: "1:1 문의 답변",
      member: true,
      owner: true,
      group: "",
      groupListBoxOpen: false,
    },
    {
      title: "신규 게시물",
      member: true,
      owner: true,
      group: "",
      groupListBoxOpen: false,
    },
    {
      title: "신규 댓글",
      member: true,
      owner: true,
      group: "",
      groupListBoxOpen: false,
    },
  ]);

  return (
    <>
      <Header />
      <MainLayout
        style={{
          position: "relative",
          gap: 306,
        }}
      >
        <Sidebar />

        {/* 본문 영역 */}
        {!showGoogleAccountSetting && (
          <DetailPageLayout>
            <TableTitle>메시지 보내기</TableTitle>
            <TabWrapper>
              <Tab
                isActive={location.pathname === route.operation_message_alarm}
                onClick={() => {
                  navigate(route.operation_message_alarm);
                }}
              >
                <TabText
                  isActive={location.pathname === route.operation_message_alarm}
                >
                  알림
                </TabText>
              </Tab>
              <Tab
                isActive={location.pathname === route.operation_message_email}
                onClick={() => {
                  navigate(route.operation_message_email);
                }}
              >
                <TabText
                  isActive={location.pathname === route.operation_message_email}
                >
                  이메일
                </TabText>
              </Tab>
              <Tab
                isActive={location.pathname === route.operation_message_sms}
                onClick={() => {
                  navigate(route.operation_message_sms);
                }}
              >
                <TabText
                  isActive={location.pathname === route.operation_message_sms}
                >
                  SMS
                </TabText>
              </Tab>
            </TabWrapper>

            <MessageEmailContainer>
              <PretendardText
                style={{
                  fontSize: 18,
                  fontWeight: 700,
                  lineHeight: "32.5px",
                  letterSpacing: "-0.3%",
                  color: "#f3f3f3",
                  marginBottom: 8,
                }}
              >
                메일 발송 설정
              </PretendardText>
              <MessageEmailItemContentText
                style={{
                  marginBottom: 16,
                }}
              >
                발송되는 메일의 주소 및 발송 서비스 업체 등을 지정합니다.
                <br />
                발송 메일이 스팸함으로 가지 않기 위해서는 올바른 발송 주소와
                서비스 업체를 선택해야 합니다.
              </MessageEmailItemContentText>
              <MessageEmailItemWrapper>
                <MessageEmailItemTitle>서비스 제공업체</MessageEmailItemTitle>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 20,
                  }}
                >
                  <SelectBoxValue
                    placeholder="항목선택"
                    disabled={true}
                    selectedValue={selectedCompany}
                    isOpen={companyListBoxOpen}
                    wrapperHandler={() => {
                      setCompanyListBoxOpen(!companyListBoxOpen);
                    }}
                    itemList={companyList}
                    selectedValueSetterFunc={(value) => {
                      setSelectedCompany(value);
                    }}
                  />
                  {/* Gmail 선택, 구글 계정 연결이 안 된 경우 */}
                  {selectedCompany === "Gmail" &&
                    !isAccountConnected.google && (
                      <EventBtn
                        onClick={() => {
                          setShowGoogleAccountSetting(true);
                          // 실제 이벤트 처리는 구글 계정 연결 창 출력 필요
                        }}
                        text={"Google 계정 연결하기"}
                      />
                    )}
                </div>
              </MessageEmailItemWrapper>

              {/* 네이버 계정 연결이 안 된 경우 */}
              {selectedCompany === "네이버" && !isAccountConnected.naver && (
                <>
                  <MessageEmailItemWrapper>
                    <MessageEmailItemTitle>
                      발신지 메일주소
                    </MessageEmailItemTitle>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 12,
                      }}
                    >
                      <MainInput
                        type={"text"}
                        placeholder={"선택한 서비스에서 사용하는 메일주소"}
                        style={{
                          width: "338px",
                        }}
                        value={""}
                        onChange={() => {}}
                      />
                      <MessageEmailItemContentText>
                        보내는 사람의 메일을 입력해주세요. <br />
                        네이버를 선택하셨다면 @naver.com 형식을 입력해야 합니다.
                      </MessageEmailItemContentText>
                    </div>
                  </MessageEmailItemWrapper>
                  <MessageEmailItemWrapper>
                    <MessageEmailItemTitle>로그인 ID</MessageEmailItemTitle>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 12,
                      }}
                    >
                      <MainInput
                        type={"text"}
                        placeholder={"선택한 서비스의 로그인 계정"}
                        style={{
                          width: "338px",
                        }}
                        value={""}
                        onChange={() => {}}
                      />
                      <MessageEmailItemContentText>
                        선택한 서비스의 로그인 계정을 입력해주세요. <br />
                        네이버를 선택하셨다면 네이버 ID를 입력합니다.
                      </MessageEmailItemContentText>
                    </div>
                  </MessageEmailItemWrapper>
                  <MessageEmailItemWrapper>
                    <MessageEmailItemTitle>비밀번호</MessageEmailItemTitle>
                    <MainInput
                      type={"text"}
                      placeholder={"선택한 서비스의 로그인 비밀번호"}
                      style={{
                        width: "338px",
                      }}
                      value={""}
                      onChange={() => {}}
                    />
                  </MessageEmailItemWrapper>
                  <MessageEmailItemWrapper>
                    <MessageEmailItemTitle>
                      인증 메일 주소
                    </MessageEmailItemTitle>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 12,
                      }}
                    >
                      <MainInput
                        type={"text"}
                        placeholder={"이메일을 입력해 주세요."}
                        style={{
                          width: "338px",
                        }}
                        value={""}
                        onChange={() => {}}
                      />
                      <MessageEmailItemContentText>
                        메일 주소 입력 후 아래 인증 메일 보내기 버튼을
                        눌러주세요.
                      </MessageEmailItemContentText>
                      <GrayBtn
                        onClick={() => {
                          setIsAccountConnected({
                            ...isAccountConnected,
                            naver: true,
                          });
                        }}
                        text={"인증 메일 보내기"}
                      />
                    </div>
                  </MessageEmailItemWrapper>
                </>
              )}

              {/* 다음 계정 연결이 안 된 경우 */}
              {selectedCompany === "다음" && !isAccountConnected.daum && (
                <>
                  <MessageEmailItemWrapper>
                    <MessageEmailItemTitle>
                      발신지 메일주소
                    </MessageEmailItemTitle>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 12,
                      }}
                    >
                      <MainInput
                        type={"text"}
                        placeholder={"선택한 서비스에서 사용하는 메일주소"}
                        style={{
                          width: "338px",
                        }}
                        value={""}
                        onChange={() => {}}
                      />
                      <MessageEmailItemContentText>
                        보내는 사람의 메일을 입력해주세요. <br />
                        다음을 선택하셨다면 @daum.net 형식을 입력해야 합니다.
                      </MessageEmailItemContentText>
                    </div>
                  </MessageEmailItemWrapper>
                  <MessageEmailItemWrapper>
                    <MessageEmailItemTitle>로그인 ID</MessageEmailItemTitle>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 12,
                      }}
                    >
                      <MainInput
                        type={"text"}
                        placeholder={"선택한 서비스의 로그인 계정"}
                        style={{
                          width: "338px",
                        }}
                        value={""}
                        onChange={() => {}}
                      />
                      <MessageEmailItemContentText>
                        선택한 서비스의 로그인 계정을 입력해주세요. <br />
                        다음을 선택하셨다면 다음 ID를 입력합니다.
                      </MessageEmailItemContentText>
                    </div>
                  </MessageEmailItemWrapper>
                  <MessageEmailItemWrapper>
                    <MessageEmailItemTitle>비밀번호</MessageEmailItemTitle>
                    <MainInput
                      type={"text"}
                      placeholder={"선택한 서비스의 로그인 비밀번호"}
                      style={{
                        width: "338px",
                      }}
                      value={""}
                      onChange={() => {}}
                    />
                  </MessageEmailItemWrapper>
                  <MessageEmailItemWrapper>
                    <MessageEmailItemTitle>
                      인증 메일 주소
                    </MessageEmailItemTitle>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 12,
                      }}
                    >
                      <MainInput
                        type={"text"}
                        placeholder={"이메일을 입력해 주세요."}
                        style={{
                          width: "338px",
                        }}
                        value={""}
                        onChange={() => {}}
                      />
                      <MessageEmailItemContentText>
                        메일 주소 입력 후 아래 인증 메일 보내기 버튼을
                        눌러주세요.
                      </MessageEmailItemContentText>
                      <GrayBtn
                        onClick={() => {
                          setIsAccountConnected({
                            ...isAccountConnected,
                            daum: true,
                          });
                        }}
                        text={"인증 메일 보내기"}
                      />
                    </div>
                  </MessageEmailItemWrapper>
                </>
              )}

              {/* 네이트 계정 연결이 안 된 경우 */}
              {selectedCompany === "네이트" && !isAccountConnected.nate && (
                <>
                  <MessageEmailItemWrapper>
                    <MessageEmailItemTitle>
                      발신지 메일주소
                    </MessageEmailItemTitle>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 12,
                      }}
                    >
                      <MainInput
                        type={"text"}
                        placeholder={"선택한 서비스에서 사용하는 메일주소"}
                        style={{
                          width: "338px",
                        }}
                        value={""}
                        onChange={() => {}}
                      />
                      <MessageEmailItemContentText>
                        보내는 사람의 메일을 입력해주세요. <br />
                        네이트를 선택하셨다면 @nate.com 형식을 입력해야 합니다.
                      </MessageEmailItemContentText>
                    </div>
                  </MessageEmailItemWrapper>
                  <MessageEmailItemWrapper>
                    <MessageEmailItemTitle>로그인 ID</MessageEmailItemTitle>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 12,
                      }}
                    >
                      <MainInput
                        type={"text"}
                        placeholder={"선택한 서비스의 로그인 계정"}
                        style={{
                          width: "338px",
                        }}
                        value={""}
                        onChange={() => {}}
                      />
                      <MessageEmailItemContentText>
                        선택한 서비스의 로그인 계정을 입력해주세요. <br />
                        네이트를 선택하셨다면 네이트 ID를 입력합니다.
                      </MessageEmailItemContentText>
                    </div>
                  </MessageEmailItemWrapper>
                  <MessageEmailItemWrapper>
                    <MessageEmailItemTitle>비밀번호</MessageEmailItemTitle>
                    <MainInput
                      type={"text"}
                      placeholder={"선택한 서비스의 로그인 비밀번호"}
                      style={{
                        width: "338px",
                      }}
                      value={""}
                      onChange={() => {}}
                    />
                  </MessageEmailItemWrapper>
                  <MessageEmailItemWrapper>
                    <MessageEmailItemTitle>
                      인증 메일 주소
                    </MessageEmailItemTitle>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 12,
                      }}
                    >
                      <MainInput
                        type={"text"}
                        placeholder={"이메일을 입력해 주세요."}
                        style={{
                          width: "338px",
                        }}
                        value={""}
                        onChange={() => {}}
                      />
                      <MessageEmailItemContentText>
                        메일 주소 입력 후 아래 인증 메일 보내기 버튼을
                        눌러주세요.
                      </MessageEmailItemContentText>
                      <GrayBtn
                        onClick={() => {
                          setIsAccountConnected({
                            ...isAccountConnected,
                            nate: true,
                          });
                        }}
                        text={"인증 메일 보내기"}
                      />
                    </div>
                  </MessageEmailItemWrapper>
                </>
              )}

              {/* 사용자 지정 SMTP 서버 계정 연결이 안 된 경우 */}
              {selectedCompany === "사용자 지정 SMTP 서버" &&
                !isAccountConnected.smtp && (
                  <>
                    <MessageEmailItemWrapper>
                      <MessageEmailItemTitle>SMTP 서버</MessageEmailItemTitle>
                      <MainInput
                        type={"text"}
                        placeholder={"IP 또는 도메인"}
                        style={{
                          width: "338px",
                        }}
                        value={""}
                        onChange={() => {}}
                      />
                    </MessageEmailItemWrapper>
                    <MessageEmailItemWrapper>
                      <MessageEmailItemTitle>SMTP 포트</MessageEmailItemTitle>
                      <MainInput
                        type={"text"}
                        placeholder={"숫자만 입력"}
                        style={{
                          width: "338px",
                        }}
                        value={""}
                        onChange={() => {}}
                      />
                    </MessageEmailItemWrapper>
                    <MessageEmailItemWrapper>
                      <MessageEmailItemTitle
                        style={{
                          marginTop: 0,
                        }}
                      >
                        인증 및 보안연결 <br />
                        (SSL)
                      </MessageEmailItemTitle>
                      <CheckboxWrapper onClick={() => {}}>
                        <Checkbox
                          style={{
                            backgroundColor: "transparent",
                          }}
                          checked={false}
                          onChange={() => {}}
                        />
                        <CheckboxText>사용</CheckboxText>
                      </CheckboxWrapper>
                    </MessageEmailItemWrapper>
                    <MessageEmailItemWrapper>
                      <MessageEmailItemTitle>로그인 ID</MessageEmailItemTitle>
                      <MainInput
                        type={"text"}
                        placeholder={"로그인 계정을 입력해주세요"}
                        style={{
                          width: "338px",
                        }}
                        value={""}
                        onChange={() => {}}
                      />
                    </MessageEmailItemWrapper>
                    <MessageEmailItemWrapper>
                      <MessageEmailItemTitle>비밀번호</MessageEmailItemTitle>
                      <MainInput
                        type={"text"}
                        placeholder={"비밀번호를 입력해주세요"}
                        style={{
                          width: "338px",
                        }}
                        value={""}
                        onChange={() => {}}
                      />
                    </MessageEmailItemWrapper>
                    <MessageEmailItemWrapper>
                      <MessageEmailItemTitle>발신자 이름</MessageEmailItemTitle>
                      <MainInput
                        type={"text"}
                        placeholder={"발신자 이름을 입력해주세요"}
                        style={{
                          width: "338px",
                        }}
                        value={""}
                        onChange={() => {}}
                      />
                    </MessageEmailItemWrapper>
                    <MessageEmailItemWrapper>
                      <MessageEmailItemTitle>
                        발신자 메일주소
                      </MessageEmailItemTitle>
                      <MainInput
                        type={"text"}
                        placeholder={"발신자 이메일 주소를 입력해주세요"}
                        style={{
                          width: "338px",
                        }}
                        value={""}
                        onChange={() => {}}
                      />
                    </MessageEmailItemWrapper>
                    <MessageEmailItemWrapper>
                      <MessageEmailItemTitle>
                        인증 메일 주소
                      </MessageEmailItemTitle>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: 12,
                        }}
                      >
                        <MainInput
                          type={"text"}
                          placeholder={"이메일을 입력해 주세요."}
                          style={{
                            width: "338px",
                          }}
                          value={""}
                          onChange={() => {}}
                        />
                        <MessageEmailItemContentText>
                          메일 주소 입력 후 아래 인증 메일 보내기 버튼을
                          눌러주세요.
                        </MessageEmailItemContentText>

                        <GrayBtn
                          onClick={() => {
                            setIsAccountConnected({
                              ...isAccountConnected,
                              smtp: true,
                            });
                          }}
                          text={"인증 메일 보내기"}
                        />
                      </div>
                    </MessageEmailItemWrapper>
                  </>
                )}

              {/* 구글 계정 연결된 경우 */}
              {selectedCompany === "Gmail" && isAccountConnected.google && (
                <>
                  <MessageEmailItemWrapper>
                    <MessageEmailItemTitle
                      style={{
                        marginTop: 0,
                      }}
                    >
                      발신 메일 주소
                    </MessageEmailItemTitle>
                    <PretendardText
                      style={{
                        fontWeight: 400,
                        fontSize: 15,
                        lineHeight: "21.25px",
                        color: "#aaa",
                      }}
                    >
                      example@gmail.com
                    </PretendardText>
                  </MessageEmailItemWrapper>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 24,
                      marginTop: 16,
                    }}
                  >
                    <MessageEmailItemContentText>
                      <span
                        style={{
                          fontFamily: "Pretendard",
                          fontWeight: 500,
                          fontSize: 13,
                          lineHeight: "18.75px",
                          color: "#cf6679",
                        }}
                      >
                        주의:{" "}
                      </span>
                      서비스 제공업체에서 제공하는 전송한도를 초과하거나
                      접속정보 변경으로 인해 메일 발송에 실패 할 수 있습니다.
                      <br />
                      Gmail 전송한도: 1회당 최대 100명, 하루 최대 500개
                    </MessageEmailItemContentText>
                    {/* <EventBtn
                      onClick={() => {
                        setIsAccountConnected({
                          ...isAccountConnected,
                          google: false,
                        });
                      }}
                      text={"Google 계정 연결 해제"}
                    /> */}
                  </div>
                </>
              )}

              {/* 네이버 계정 연결된 경우 */}
              {selectedCompany === "네이버" && isAccountConnected.naver && (
                <>
                  <MessageEmailItemWrapper>
                    <MessageEmailItemTitle
                      style={{
                        marginTop: 0,
                      }}
                    >
                      발신 메일 주소
                    </MessageEmailItemTitle>
                    <PretendardText
                      style={{
                        fontWeight: 400,
                        fontSize: 15,
                        lineHeight: "21.25px",
                        color: "#aaa",
                      }}
                    >
                      example@naver.com
                    </PretendardText>
                  </MessageEmailItemWrapper>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 24,
                      marginTop: 16,
                    }}
                  >
                    <MessageEmailItemContentText>
                      <span
                        style={{
                          fontFamily: "Pretendard",
                          fontWeight: 500,
                          fontSize: 13,
                          lineHeight: "18.75px",
                          color: "#cf6679",
                        }}
                      >
                        주의:{" "}
                      </span>
                      서비스 제공업체에서 제공하는 전송한도를 초과하거나
                      접속정보 변경으로 인해 메일 발송에 실패 할 수 있습니다.
                      <br />
                      네이버 전송한도: 시간당 최대 30회, 1회당 최대 100명
                    </MessageEmailItemContentText>
                    <EventBtn
                      onClick={() => {
                        setIsAccountConnected({
                          ...isAccountConnected,
                          naver: false,
                        });
                      }}
                      text={"네이버 계정 연결 해제"}
                    />
                  </div>
                </>
              )}

              {/* 다음 계정 연결된 경우 */}
              {selectedCompany === "다음" && isAccountConnected.daum && (
                <>
                  <MessageEmailItemWrapper>
                    <MessageEmailItemTitle
                      style={{
                        marginTop: 0,
                      }}
                    >
                      발신 메일 주소
                    </MessageEmailItemTitle>
                    <PretendardText
                      style={{
                        fontWeight: 400,
                        fontSize: 15,
                        lineHeight: "21.25px",
                        color: "#aaa",
                      }}
                    >
                      example@daum.net
                    </PretendardText>
                  </MessageEmailItemWrapper>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 24,
                      marginTop: 16,
                    }}
                  >
                    <MessageEmailItemContentText>
                      <span
                        style={{
                          fontFamily: "Pretendard",
                          fontWeight: 500,
                          fontSize: 13,
                          lineHeight: "18.75px",
                          color: "#cf6679",
                        }}
                      >
                        주의:{" "}
                      </span>
                      서비스 제공업체에서 제공하는 전송한도를 초과하거나
                      접속정보 변경으로 인해 메일 발송에 실패 할 수 있습니다.
                      <br />
                      다음 전송한도: 다음 정책에 따라 비공개
                    </MessageEmailItemContentText>
                    <EventBtn
                      onClick={() => {
                        setIsAccountConnected({
                          ...isAccountConnected,
                          daum: false,
                        });
                      }}
                      text={"다음 계정 연결 해제"}
                    />
                  </div>
                </>
              )}

              {/* 네이트 계정 연결된 경우 */}
              {selectedCompany === "네이트" && isAccountConnected.nate && (
                <>
                  <MessageEmailItemWrapper>
                    <MessageEmailItemTitle
                      style={{
                        marginTop: 0,
                      }}
                    >
                      발신 메일 주소
                    </MessageEmailItemTitle>
                    <PretendardText
                      style={{
                        fontWeight: 400,
                        fontSize: 15,
                        lineHeight: "21.25px",
                        color: "#aaa",
                      }}
                    >
                      example@nate.com
                    </PretendardText>
                  </MessageEmailItemWrapper>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 24,
                      marginTop: 16,
                    }}
                  >
                    <MessageEmailItemContentText>
                      <span
                        style={{
                          fontFamily: "Pretendard",
                          fontWeight: 500,
                          fontSize: 13,
                          lineHeight: "18.75px",
                          color: "#cf6679",
                        }}
                      >
                        주의:{" "}
                      </span>
                      서비스 제공업체에서 제공하는 전송한도를 초과하거나
                      접속정보 변경으로 인해 메일 발송에 실패 할 수 있습니다.
                      <br />
                      네이트 전송한도: 네이트 정책에 따라 비공개
                    </MessageEmailItemContentText>
                    <EventBtn
                      onClick={() => {
                        setIsAccountConnected({
                          ...isAccountConnected,
                          nate: false,
                        });
                      }}
                      text={"네이트 계정 연결 해제"}
                    />
                  </div>
                </>
              )}

              {/* 사용자 지정 SMTP 서버 계정 연결된 경우 */}
              {selectedCompany === "사용자 지정 SMTP 서버" &&
                isAccountConnected.smtp && (
                  <>
                    <MessageEmailItemWrapper>
                      <MessageEmailItemTitle
                        style={{
                          marginTop: 0,
                        }}
                      >
                        발신 메일 주소
                      </MessageEmailItemTitle>
                      <PretendardText
                        style={{
                          fontWeight: 400,
                          fontSize: 15,
                          lineHeight: "21.25px",
                          color: "#aaa",
                        }}
                      >
                        example@writingcrew.com
                      </PretendardText>
                    </MessageEmailItemWrapper>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 24,
                        marginTop: 16,
                      }}
                    >
                      <MessageEmailItemContentText>
                        <span
                          style={{
                            fontFamily: "Pretendard",
                            fontWeight: 500,
                            fontSize: 13,
                            lineHeight: "18.75px",
                            color: "#cf6679",
                          }}
                        >
                          주의:{" "}
                        </span>
                        서비스 제공업체에서 제공하는 전송한도를 초과하거나
                        접속정보 변경으로 인해 메일 발송에 실패 할 수 있습니다.
                      </MessageEmailItemContentText>
                      <EventBtn
                        onClick={() => {
                          setIsAccountConnected({
                            ...isAccountConnected,
                            smtp: false,
                          });
                        }}
                        text={"계정 연결 해제"}
                      />
                    </div>
                  </>
                )}

              {/* 자동 메일 설정 테이블 영역 */}
              {selectedCompany !== "" && (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <PretendardText
                    style={{
                      fontSize: 18,
                      fontWeight: 700,
                      lineHeight: "32.5px",
                      letterSpacing: "-0.3%",
                      color: "#f3f3f3",
                      margin: "70px 0px 7px 0px",
                    }}
                  >
                    자동 메일 설정
                  </PretendardText>
                  <MessageEmailItemContentText
                    style={{
                      marginBottom: 32,
                    }}
                  >
                    자동 메일을 설정하시면 상황에 따라 고객이나 운영자에게
                    메일이 발송됩니다.
                    <br />
                    네이버페이 구매는 구매자용 각종 알림 메일을 보내지 않습니다.
                    네이버에서 대신 발송해 줍니다.
                  </MessageEmailItemContentText>
                  {/* 테이블 영역 */}
                  <Table>
                    <colgroup>
                      {/* 합계: 1044px */}
                      {/* 항목 */}
                      <col width="495px" />
                      {/* 회원 */}
                      <col width="87px" />
                      {/* 소유자 */}
                      <col width="160px" />
                      {/* 운영진 그룹 */}
                      <col width="302px" />
                    </colgroup>
                    <thead>
                      <Tr style={{ height: "41px", background: "#272829" }}>
                        <Th style={{ paddingLeft: "32px" }}>
                          <TableText
                            style={{
                              fontWeight: "600",
                              lineHeight: "22.75px",
                            }}
                          >
                            항목
                          </TableText>
                        </Th>
                        <Th>
                          <TableText
                            style={{
                              fontWeight: "600",
                              lineHeight: "22.75px",
                            }}
                          >
                            회원
                          </TableText>
                        </Th>
                        <Th>
                          <TableText
                            style={{
                              fontWeight: "600",
                              lineHeight: "22.75px",
                            }}
                          >
                            소유자
                          </TableText>
                        </Th>
                        <Th>
                          <TableText
                            style={{
                              fontWeight: "600",
                              lineHeight: "22.75px",
                            }}
                          >
                            운영진 그룹
                          </TableText>
                        </Th>
                      </Tr>
                    </thead>
                    <tbody>
                      {autoSendSettingList.map((item, index) => {
                        return (
                          <Tr
                            key={index}
                            style={{
                              height: "59px",
                              padding: "20px 0px",
                              background: "transparent",
                              borderBottom:
                                "0.5px solid rgba(255, 255, 255, 0.12)",
                            }}
                          >
                            {/* 항목 */}
                            <Td style={{ paddingLeft: "32px" }}>
                              <TableText>{item.title}</TableText>
                            </Td>
                            {/* 회원 */}
                            <Td>
                              {item.title !== "신규 게시물" &&
                                item.title !== "신규 댓글" && (
                                  <Checkbox
                                    style={{
                                      backgroundColor: "transparent",
                                    }}
                                    checked={item.member}
                                    onChange={() => {
                                      autoSendSettingList[index].member =
                                        !item.member;
                                      setAutoSendSettingList([
                                        ...autoSendSettingList,
                                      ]);
                                    }}
                                  />
                                )}
                            </Td>
                            {/* 소유자 */}
                            <Td>
                              <Checkbox
                                style={{
                                  backgroundColor: "transparent",
                                }}
                                checked={item.owner}
                                onChange={() => {
                                  autoSendSettingList[index].owner =
                                    !item.owner;
                                  setAutoSendSettingList([
                                    ...autoSendSettingList,
                                  ]);
                                }}
                              />
                            </Td>
                            <Td>
                              <SelectGroupBox
                                placeholder={"그룹선택"}
                                selectedValues={item.group}
                                isOpen={item.groupListBoxOpen}
                                wrapperHandler={() => {
                                  autoSendSettingList[index].groupListBoxOpen =
                                    !item.groupListBoxOpen;
                                  setAutoSendSettingList([
                                    ...autoSendSettingList,
                                  ]);
                                }}
                                itemList={autoSendGroupList}
                                selectedValueSetterFunc={(value) => {
                                  autoSendSettingList[index].group = value;
                                  setAutoSendSettingList([
                                    ...autoSendSettingList,
                                  ]);
                                }}
                              />
                            </Td>
                          </Tr>
                        );
                      })}
                    </tbody>
                  </Table>
                </div>
              )}
            </MessageEmailContainer>
          </DetailPageLayout>
        )}

        {/* Gmail 계정 연결 화면 */}
        {showGoogleAccountSetting && (
          <DetailPageLayout>
            <TableTitle>메일 발송 설정</TableTitle>
            <div
              style={{
                width: "100%",
                height: "fit-content",
                marginTop: 264,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 22,
              }}
            >
              <PretendardText
                style={{
                  fontWeight: 700,
                  fontSize: 30,
                  lineHeight: "41.5px",
                  letterSpacing: "-0.7%",
                  color: "#aaa",
                }}
              >
                Gmail 보안 연결
              </PretendardText>
              <PretendardText
                style={{
                  fontWeight: 400,
                  fontSize: 15,
                  lineHeight: "21.25px",
                  textAlign: "center",
                  color: "#aaa",
                }}
              >
                구글 계정 연결이 끝나셨나요?
                <br />
                아래 확인 버튼을 눌러 메일 발송 설정에서 연결된 계정을
                확인해주세요
              </PretendardText>
              <EventBtn
                onClick={() => {
                  setShowGoogleAccountSetting(false);
                  setIsAccountConnected({
                    ...isAccountConnected,
                    google: true,
                  });
                }}
                text={"메일 발송 설정 확인"}
              />
            </div>
          </DetailPageLayout>
        )}
      </MainLayout>
    </>
  );
};

export default OperationMessageEmail;

const TabWrapper = styled.div.attrs((props) => {})`
  width: fit-content;
  display: flex;
  gap: 10px;
  align-items: center;
  margin-bottom: 30px;
`;

const Tab = styled.div.attrs((props) => {})`
  width: fit-content;
  height: fit-content;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 19px 28px;
  border-bottom: ${(props) => (props.isActive ? "2px solid #27beff" : "none")};
  cursor: pointer;
`;

const TabText = styled(PretendardText).attrs((props) => {})`
  font-weight: 700;
  font-size: 16px;
  line-height: 25px;
  letter-spacing: -0.3%;
  color: ${(props) =>
    props.isActive ? "#27beff" : "rgba(181, 181, 181, 0.5)"};
`;

const MessageEmailContainer = styled.div.attrs((props) => {})`
  display: flex;
  flex-direction: column;
`;

const MessageEmailItemContentText = styled(PretendardText).attrs((props) => {})`
  font-weight: 500;
  font-size: 13px;
  line-height: 18.75px;
  color: rgba(181, 181, 181, 0.5);
`;

const MessageEmailItemWrapper = styled.div.attrs((props) => {})`
  width: 100%;
  height: fit-content;
  display: flex;
  border-bottom: 0.5px solid var(--outline1, rgba(255, 255, 255, 0.12));
  padding: 21px 0px;
`;

const MessageEmailItemTitle = styled(PretendardText).attrs((props) => {})`
  width: 122px;
  height: fit-content;
  font-weight: 600;
  font-size: 14px;
  line-height: 22.75px;
  color: #aaa;
  margin-top: 12px;
`;

const CheckboxWrapper = styled.div.attrs((props) => {})`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const CheckboxText = styled(PretendardText).attrs((props) => {})`
  font-size: 15px;
  font-weight: 500;
  line-height: 21.5px;
  color: #aaa;
`;
